export default __webpack_public_path__ + "static/media/kognitif.138ccae5.png";